<!-- Секция настроек со ссылками на справочники. -->
<template>
  <SettingSection
    title="Справочники"
    icon-variant="reference"
    :icon="icon"
    :links="links"
  />
</template>

<script>
import { mapActions, mapState } from "pinia";

import SettingSection from "@/components/Settings/SettingSection.vue";
import { useReferenceItemsStore } from "@/stores/referenceItemsStore";

export default {
  name: "ReferenceSettingsSection",

  components: {
    SettingSection,
  },

  data() {
    return {
      icon: `
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
        <line x1="9" y1="7" x2="15" y2="7"></line>
        <line x1="9" y1="11" x2="15" y2="11"></line>
      `,
    };
  },

  computed: {
    ...mapState(useReferenceItemsStore, ["targets"]),

    links() {
      return this.targets.map((target) => ({
        label: target.title,
        route: {
          name: "ReferenceItems",
          query: {
            target_model: target.target_model,
            target_field: target.target_field,
            title: target.title,
          },
        },
      }));
    },
  },

  methods: {
    ...mapActions(useReferenceItemsStore, ["fetchTargets"]),
  },

  async created() {
    await this.fetchTargets();
  },
};
</script>
